export const BUYER_ERROR_REASONS = {
  IDENTITY_MISMATCH: 'Identity_Mismatch',
  BUYER_VALIDATION: 'Buyer_Validation',
  EMAIL_ALREADY_EXISTS: 'Email_Already_Exists',
  PHONE_ALREADY_EXISTS: 'Phone_Already_Exists',
  BUYER_CONFLICT: 'Buyer_Conflict',
};
